import React from 'react';

import DatePickerField from 'CommonComponents/DatePickerField';
import FormSectionHeading from 'CommonComponents/FormSectionHeading';

export default function KeyDatesInputsGrid({ values, errors, touched, setFieldValue, disabled, eventStartDate, eventEndDate }) {
    const dateFields = [
        {
            label: $t('Scope Issue to Market'),
            items: ['target_scope_issue_to_market_date', 'expected_scope_issue_to_market_date', 'actual_scope_issue_to_market_date'],
        },
        { label: $t('Response Due Date'), items: ['target_response_due_date', 'expected_response_due_date', 'actual_response_due_date'] },
        { label: $t('Decision Date'), items: ['target_decision_date', 'expected_decision_date', 'actual_decision_date'] },
        { label: $t('Contract Award Date'), items: ['target_contract_award_date', 'expected_contract_award_date', 'actual_contract_award_date'] },
        {
            label: $t('Contract Completion Date'),
            items: ['target_contract_completion_date', 'expected_contract_completion_date', 'actual_contract_completion_date'],
        },
    ];

    const getLabelText = (index) => {
        if (index == 0) {
            return 'Target';
        } else if (index == 1) {
            return 'Expected';
        } else {
            return 'Actual';
        }
    };

    return (
        <>
            <div className="tw-hidden md:tw-grid tw-grid-cols-12 tw-gap-4">
                <div className="tw-col-span-12 md:tw-col-span-3">
                    <FormSectionHeading heading={$t('Key Dates')}></FormSectionHeading>
                </div>
                <div className="tw-col-span-12 md:tw-col-span-3 tw-text-center">
                    <FormSectionHeading heading={$t('Target')}></FormSectionHeading>
                </div>
                <div className="tw-col-span-12 md:tw-col-span-3 tw-text-center">
                    <FormSectionHeading heading={$t('Expected')}></FormSectionHeading>
                </div>
                <div className="tw-col-span-12 md:tw-col-span-3 tw-text-center">
                    <FormSectionHeading heading={$t('Actual')}></FormSectionHeading>
                </div>
            </div>
            {dateFields.map(({ label, items }, index) => (
                <div className="tw-grid tw-grid-cols-12 tw-gap-4" key={label + index}>
                    <div className="tw-col-span-12 md:tw-col-span-3">
                        <label className="tw-text-sm tw-font-semibold tw-block md:tw-hidden">{label}</label>
                        <label className="text-input__label tw-hidden md:tw-block">{label}</label>
                    </div>
                    {items.map((item, subIndex) => {
                        return (
                            <div className="tw-col-span-12 md:tw-col-span-3" key={item}>
                                <div className="tw-grid tw-grid-cols-12 tw-gap-4 md:tw-gap-0">
                                    <label className="tw-col-span-3 md:tw-col-span-12 text-input__label tw-block md:tw-hidden">
                                        {$t(getLabelText(subIndex))}
                                    </label>
                                    <div className="tw-col-span-9 md:tw-col-span-12 tw-flex tw-flex-col tw-space-y-1.5">
                                        <DatePickerField
                                            name={item}
                                            valueFormat="yyyy-MM-dd"
                                            dateFormat="yyyy-MM-dd"
                                            className={errors[item] && touched[item] ? 'tw-border tw-border-red-500 text-input' : 'tw-border-0 text-input'}
                                            value={values[item]}
                                            min={eventStartDate}
                                            max={eventEndDate}
                                            onChange={setFieldValue}
                                            onFocus={() => {
                                                if (!values[item] && index > 0) {
                                                    const prevDate = values[dateFields[index - 1].items[subIndex]];
                                                    setFieldValue(item, prevDate);
                                                }
                                            }}
                                            disabled={disabled}
                                        />
                                        {errors[item] && touched[item] && <div className="tw-text-red-500 tw-text-sm">{errors[item]}</div>}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            ))}
        </>
    );
}
